export default __webpack_public_path__ + "static/media/RhHEJvcp.721b71f8.svg";